<div class="container-fluid">
    <app-submenu-tabs section="NEGOTIATION"></app-submenu-tabs>
    <router-outlet></router-outlet>    
</div>